export default __webpack_public_path__ + "navigation-camera-pitch-near-maneuver-enabled-1200-59dc6ae27049e4ca34bcd3528add39b9.webp";